export default __webpack_public_path__ + "static/media/Jaws.674d32d6.mp3";